import TermsAndConditions from '@module/terms-and-conditions';
import Privacy from '@module/privacy';

const sideloaded = window['__session__'] || {};

export default {
  language: sideloaded.user.language, // what language
  tandc: TermsAndConditions.areAccepted(), // accepted T&C or not
  // Does the user allow tracking after clicking the banner
  privacy: {
    notified: Privacy.userHasClosedBanner(),
    allowTracking: Privacy.userAllowsTracking(),
  },
  plus: sideloaded.user.id || false, // is logged in or not
  domain: sideloaded.settings.cookie_domain,
  compatibility_version: sideloaded.settings.compatibility_version,
  incompatible_version: false,
  region: {
    country: sideloaded.region.country, // what country is this client (ip)
    continent: sideloaded.region.continent, // what continent is this client (ip)
    currency: sideloaded.region.currency, //currency base on user country
  },
  domainUserId: null,
};
